import { useTranslation } from 'react-i18next';

import styles from './PredictionCard.module.scss';

export function NoPredictions() {
  const { t } = useTranslation('testModel');
  return <div className={styles.predictionErrorContainer}>{t('noPredictions')}</div>;
}
